// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","services":"services-3dHUa","services_horizontal":"services_horizontal-3BlXL"};